import { render, staticRenderFns } from "./content-detail.view.vue?vue&type=template&id=d6d2130c&"
import script from "./content-detail.view.vue?vue&type=script&lang=ts&"
export * from "./content-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports